// https://api.ehrenkind.de/v1/shop/product/waitlist/confirm

class WaitlistForm extends HTMLElement {
    constructor() {
      super();

      this.busy = false;

      this.emailInput = this.querySelector('input[name="email"]');
      this.emailInput.addEventListener('keyup', this.onEmailInputChange.bind(this));

      this.button = this.querySelector('button');
      this.button.addEventListener('click', this.onButtonClick.bind(this));
      this.button.disabled = !this.emailInput.value;

      this.sku = this.querySelector('input[name="product_sku"]').value;
      this.title = this.querySelector('input[name="product_title"]').value;

      this.icon_arrow = this.querySelector('.icon_arrow');
      this.icon_checkmark = this.querySelector('.icon_checkmark');
      this.message = this.querySelector('.message');
      this.message.textContent = "Test";
    }

    onEmailInputChange(event) {
      if(this.emailInput.value) {
        this.button.disabled = false;
      } else {
        this.button.disabled = true;
      }

      if (event.keyCode === 13) {
        this.button.click();
      }
    }

    async onButtonClick(event) {
      event.preventDefault();

      if (!this.emailInput.value) {
        this.emailInput.focus();
        return;
      }

      if (this.busy) return;

      this.busy = true;
      this.emailInput.disabled = true;
      this.hideMessage();

      const data = {
        email: this.emailInput.value,
        sku: this.sku,
        title: this.title
      };

      try {
        const response = await fetch('https://api.ehrenkind.de/v1/shop/product/waitlist/confirm', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ data })
        });

        if (response.ok) {
          this.icon_arrow.classList.add('hidden');
          this.icon_checkmark.classList.remove('hidden');

          this.showMessage("Das hat geklappt! Schau in den nächsten 30 Minuten in dein Postfach um deinen Platz auf der Warteliste zu bestätigen.")
        } else {
          this.resetForm();
          this.showMessage("Das hat nicht geklappt! Probiere es bitte später erneut oder melde dich bei unserem Kundenservice.");
        }
      } catch (error) {
        this.resetForm();
        this.showMessage("Es gab ein Problem bei der Verbindung. Probiere es bitte später erneut oder melde dich bei unserem Kundenservice.");
      }
    }

    resetForm() {
      this.busy = false;
      this.emailInput.value = '';
      this.emailInput.disabled = false;
    }

    hideMessage() {
      this.message.classList.add('hidden');
      this.message.textContent = '';
    }
    
    showMessage(message) {
      this.message.textContent = message;
      this.message.classList.remove('hidden');
    }
  }
  
  customElements.define('waitlist-form', WaitlistForm);